/**
 * Rarity (`docs/achievements-plan.md` §9.5): how many of a game's players hold an achievement, said
 * the same way on every surface — the unlock moment's card, the library, a profile, the dashboard.
 * Its own module because the unlock moment's spec carries the bands (`unlock-moment.ts`) and the
 * record envelope carries the tiers (`play.ts`), and neither may import the other.
 */
/**
 * Rarity (§9.5): holders over everyone who sent any play record on the `public` channel, and **not
 * shown below this many players** — the surfaces show nothing rather than *100%*.
 */
export const RARITY_MIN_PLAYERS = 20;
/**
 * PlayStation's four bands, for surfaces that want a word (§2.4, §9.5), rarest last. The unlock
 * moment's tiers are cut on their own two lines (`UNLOCK_RARE_BELOW`, `UNLOCK_ULTRA_BELOW` in
 * `unlock-moment.ts`), which fall on these bands' edges.
 */
export const RARITY_BANDS = [
    { word: 'Common', from: 0.5 },
    { word: 'Rare', from: 0.15 },
    { word: 'Very rare', from: 0.05 },
    { word: 'Ultra rare', from: 0 },
];
/** `holders / players`, or null below `RARITY_MIN_PLAYERS`. */
export function rarityShare(holders, players) {
    if (!(players >= RARITY_MIN_PLAYERS) || !(holders >= 0))
        return null;
    return Math.min(1, holders / players);
}
/** The band a share falls in. */
export function rarityWord(share) {
    return (RARITY_BANDS.find((band) => share >= band.from) ?? RARITY_BANDS[3]).word;
}
/** A share as every surface writes it: whole percents, and *< 1%* below one (§9.5). */
export function rarityPercent(share) {
    const percent = share * 100;
    return percent > 0 && percent < 1 ? '< 1%' : `${Math.round(percent)}%`;
}
//# sourceMappingURL=rarity.js.map